<template>
  <div class="content-1">
    <h3>{{ transPeralbaPro.item805 }}</h3>
    <h4>{{ transPeralbaPro.item806 }}</h4>

    <form
      class=""
      id="login-form"
      @submit.prevent="handleResetPassword"
      method="POST"
    >
      <form-input
        fieldName="email"
        :fieldLabel="transPeralbaPro.item793"
        fieldType="email"
        :fieldValue="email"
        :inputPlaceholder="transPeralbaPro.item794"
        :is-required="true"
        @updateValue="updateEmailValue"
      />

      <div class="form-group">
        <button
          type="button"
          :disabled="disabledForm"
          class="btn-per-dark w-100"
          @click="handleResetPassword"
        >
          {{ transPeralbaPro.item807 }}
        </button>
      </div>
      <div class="mt-3">
        <div
          class="alert alert-danger"
          v-for="(error, index) in errors"
          :key="index"
        >
          {{ error.msg }}
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import HTTP from "../../../../services/http";

import FormInput from "../../../../components/front/Inputs/FormInput";
export default {
  props: ["email", "routeResetPassword", "disabledForm", "transPeralbaPro"],
  components: { FormInput },
  data() {
    return {
      errors: [],
    };
  },
  methods: {
    updateEmailValue(event) {
      this.$emit("updateField", event.value);
    },

    handleResetPassword(e) {
      e.preventDefault();
      this.errors = [];

      const csrf = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
      this.$emit("loading", true);
      HTTP.post(this.routeResetPassword, {
        email: this.email,
        _token: csrf,
      })
        .then((r) => {
          if (r.data.status == 1) {
            this.$emit("changeView", 5);
          } else {
            this.errors.push(r.data);
          }
          this.$emit("loading", false);
        })
        .catch((e) => {
          this.errors.push(e.response.data);
          this.$emit("loading", true);
        });
    },
  },
};
</script>
